<style lang="scss" src="./CookiesBanner.scss"></style>
<script lang="ts" src="./CookiesBanner.ts"></script>

<template>
  <div id="cookie-consent-banner" class="cookie-consent">
    <div class="cookie-consent__content">
      <div class="cookie-consent__text">
        <p>
          {{ cookiesDescription }}
          <a
            href="https://vaultn.com/cookie-notice/"
            class="cookie-consent__notice-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            Read our Cookie Notice
          </a>
        </p>
      </div>
      <div class="cookie-consent__buttons">
        <button
          id="cookie-accept-all"
          class="cookie-consent__button cookie-consent__button--primary"
          type="button"
          @click="$emit('accept-all')"
        >
          Accept All
        </button>
        <button
          id="cookie-accept-essential"
          class="cookie-consent__button cookie-consent__button--secondary"
          type="button"
          @click="$emit('accept-essential')"
        >
          Essential Only
        </button>
        <button
          id="cookie-settings"
          class="cookie-consent__button cookie-consent__button--tertiary"
          type="button"
          @click="$emit('navigate-settings')"
        >
          Cookie Settings
        </button>
      </div>
    </div>
  </div>
</template>
